import { createFileRoute } from "@tanstack/react-router";
import WhatsNew from "@/pages/WhatsNew";

export const Route = createFileRoute("/_app/whats-new")({
  component: WhatsNew,
});
